/// <amd-module name="Feed/Legacy/Components/ExternalLink" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import { ILinkProps, Link } from "VSSUI/Link";

import { CiConstants } from "Feed/Common/Constants/Constants";
import { CustomerIntelligenceHelper } from "Feed/Legacy/Helpers/CustomerIntelligenceHelper";
import { isAbsoluteUrl, isSafeProtocol } from "Feed/Legacy/Helpers/UrlHelper";

export interface IExternalLinkProps extends ILinkProps {
    pageContext: IVssPageContext;
    ciContext?: string;

    // if ciFeature is not supplied, CiConstants.ExternalLink will be used
    ciFeature?: string;
    onClick?: (
        ev:
            | React.MouseEvent<HTMLAnchorElement | HTMLElement | HTMLButtonElement>
            | React.KeyboardEvent<HTMLAnchorElement | HTMLElement | HTMLButtonElement>
    ) => void;
    linkAriaLabel?: string;
    underline?: boolean;
}

export class ExternalLink extends React.PureComponent<IExternalLinkProps> {
    public render(): JSX.Element {
        // decode so query parameters are handled properly
        const href = decodeURIComponent(this.props.href);
        // data, javascript, vbscript will be removed. file is safe protocol but we want
        // to remove that as well
        if (isAbsoluteUrl(href) && !isSafeProtocol(href)) {
            return <div>{href}</div>;
        }

        return (
            <Link
                ariaLabel={this.props.linkAriaLabel}
                target="_blank"
                rel="noopener noreferrer"
                {...this.props}
                href={href}
                onClick={ev => this._onClick(ev)}
                underline={this.props.underline}
            >
                {this.props.children}
            </Link>
        );
    }

    private _onClick(ev: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>): void {
        CustomerIntelligenceHelper.publishEvent(
            this.props.pageContext,
            this.props.ciFeature || CiConstants.ExternalLink,
            {
                URL: this.props.href,
                context: this.props.ciContext,
                title: this.props.title
            }
        );

        if (this.props.onClick) {
            this.props.onClick(ev);
        }
    }
}
